import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SmoothScroll from "./components/SmoothScroll";
import CartDrawer from "./components/CartDrawer";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Vestiaire from "./pages/Vestiaire";
import Product from "./pages/Product";
import Univers from "./pages/Univers";
import MondeDetail from "./pages/MondeDetail";
import Journal from "./pages/Journal";
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Legal from "./pages/Legal";
import Connexion from "./pages/Connexion";
import Inscription from "./pages/Inscription";
import AuthCallback from "./pages/AuthCallback";
import MonCarnet from "./pages/MonCarnet";
import APropos from "./pages/APropos";
import Contact from "./pages/Contact";
// import Transmission from "./pages/Transmission"; // page préparée, non publique

/**
 * Detect Emergent OAuth return synchronously (before any route renders)
 * to avoid race conditions with the AuthProvider /me check.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
 */
function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/vestiaire" element={<Vestiaire />} />
      <Route path="/vestiaire/:slug" element={<Product />} />
      <Route path="/archives" element={<Univers />} />
      <Route path="/archives/:slug" element={<MondeDetail />} />
      <Route path="/a-propos" element={<APropos />} />
      {/* <Route path="/transmission" element={<Transmission />} /> — activer avec 2-3 entrées réelles */}
      <Route path="/univers" element={<Navigate to="/archives" replace />} />
      <Route path="/univers/:slug" element={<Navigate to="/archives" replace />} />
      <Route path="/atelier" element={<Navigate to="/archives" replace />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/journal" element={<Journal />} />
      <Route path="/connexion" element={<Connexion />} />
      <Route path="/inscription" element={<Inscription />} />
      <Route path="/mon-carnet" element={<ProtectedRoute><MonCarnet /></ProtectedRoute>} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/checkout/success" element={<CheckoutSuccess />} />
      <Route path="/mentions-legales" element={<Legal />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App grain">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <CartProvider>
              <SmoothScroll>
                <Header />
                <AppRoutes />
                <Footer />
                <CartDrawer />
              </SmoothScroll>
            </CartProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
